
// CODE FOR GO TO TOP BUTTON

// window.onload = () => {
//   //Get the button
//   const goToTopButton = document.getElementById("btnGoToTop");
//   goToTopButton?.addEventListener('click', topFunction);
// }

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () { scrollFunction() };

function scrollFunction() {
    const goToTopButton = document.getElementById("btnGoToTop");
    if (goToTopButton) {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            goToTopButton.style.display = "block";
        } else {
            goToTopButton.style.display = "none";
        }
    }
}
//

// Animate.css - a function to add the animations classes and remove them automatically:
export const animateCSS = (element, animation, duration = '0.3s', delay = '0s') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const prefix = 'animate__';
        const animationName = `${animation}`;
        const node = document.querySelector(element);

        node.style.animationDuration = duration;
        node.style.animationDelay = delay;
        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });


// Calculate date difference
export function dateDiff(d1, d2 = new Date()) {
    var d1Y = d1.getFullYear();
    var d2Y = d2.getFullYear();
    var d1M = d1.getMonth();
    var d2M = d2.getMonth();

    var totalMonths = (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
    var years = totalMonths / 12;
    var months = totalMonths % 12;

    return `${Math.floor(years)} Years, ${Math.ceil(months)} Months`;
}